import React from "react";
import {Modal, Select} from "antd";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_SKIM } from "../../constants/urls";
import { dateToHumanString, formatComma } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";

export default function StockSkimSellModal(props){
  const { open, onClose } = props;
  const [filterProductAmount, setFilterProductAmount] = React.useState(true)
  const [ errorMessages, setErrorMessages] = React.useState(null);
  const tableRef = React.useRef(null);

  const refreshDataFilter = async (params) => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetch(params);
      } catch (error) { 
        setErrorMessages(error.errorMessages);
      }
    }
  };

  const columns = [
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render :(value) => <center>{dateToHumanString(value)}</center>
    },
    {
      title: 'พาเลท/เลขสต๊อก',
      dataIndex: 'stock_no',
      key: 'stock_no',
      searcher: true,
      render : (value) => value ? value : '-'
    },
    {
      title: 'ล็อตการผลิต',
      dataIndex: 'sources_no',
      key: 'sources_no',
      searcher: true,
      render : (value) => value ? value : '-'
    },
    {
      title: 'สินค้า',
      dataIndex: 'product_name',
      key: 'product_name',
      render : (value) => value ? value : '-'
    },
    {
      title: 'จำนวนทั้งหมด',
      dataIndex: 'amount',
      key: 'amount',
      render : (value) => <center>{value ? formatComma(value) : 0}</center>
    },
    {
      title: 'จำนวนคงเหลือ',
      dataIndex: 'current',
      key: 'current',
      render : (value) => <center>{value ? formatComma(value) : 0}</center>
    },
    {
      title: 'ชื่อย่อ',
      dataIndex: 'product_short_name', 
      key: 'product_short_name',  
    },
  ]

  return(
    <Modal
      title={"สต๊อกสกิม"}
      open={open}
      onCancel={onClose}
      okText={"ตกลง"}
      cancelText={"ยกเลิก"}
      width={1000}
      destroyOnClose
      footer={[
        <ColorButton onClick={()=> onClose()}>ปิด</ColorButton>
      ]}
    >
      สถานะ : 
      <Select
        style={{ marginLeft : 10, width : 250,  marginBottom : 10}}
        options={[
          {
            label : "มีสินค้า/กำลังดำเนินการ",
            value : true
          },
          {
            label : "สินค้าหมด",
            value : false
          },
          {
            label : "ทั้งหมด",
            value : ''
          },
        ]}
        value={filterProductAmount}
        onChange={(e) => {
          setFilterProductAmount(e)
          refreshDataFilter({ has_product_amount : e})
        }}
      />
      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_SKIM.SKIM_STOCK}
        params={{has_product_amount : filterProductAmount }}
      />

    </Modal>
    
  )
}